import { useQuery } from "react-query";
import axiosClient from "../../lib/axios";
import { Select, MenuItem, FormControl, InputLabel } from "@mui/material";
import { useEffect, useMemo } from "react";
import { IDataCondicoesPagamentoComercial } from "../../types/api/comercial/pesquisar-condicoes-pagamento";

export default function SelectCondicoesPagamento({
    value,
    onChange,
    loja_id,
    condicoes_pagamento_blocked,
    valor_total,
    situacao_financeira,
    produtor_rural,
    tipo_publico,
    codigo_publico,
    status = "Ativa",
    autoSelectFirst = false,
    desabilitarInput = false,
    defaultValue = false,
}: SelectSimpleApiQueryProps) {

    //queries e mutations
    const { data, isLoading } = useQuery({
        queryKey: ["pesquisar-condicoes-pagamento", loja_id, condicoes_pagamento_blocked, valor_total, tipo_publico, codigo_publico, status],
        queryFn: () => axiosClient.get("/comercial/pedidos/pesquisar-condicoes-pagamento", {
            params: {
                loja_id,
                condicoes_pagamento_blocked,
                valor_total,
                situacao_financeira,
                produtor_rural,
                tipo_publico,
                codigo_publico,
                status
            }
        }),
        enabled: !!loja_id,
        cacheTime: 0,
        staleTime: 0
    });
    const listData: IDataCondicoesPagamentoComercial[] = useMemo(() => data?.data || [], [data])

    // Pre-selecionar o primeiro registro
    useEffect(() => {
        if (listData.length > 0 && !value && autoSelectFirst) {
            onChange(listData[0]);
        }
        if (defaultValue && value && autoSelectFirst && listData.length > 0) {
            const valor = listData.find(i => i.id === value.id)
            if (!valor) return;
            onChange(valor);
        }
    }, [listData, value, onChange, autoSelectFirst, defaultValue]);
    //

    return (
        <FormControl fullWidth disabled={isLoading || desabilitarInput || !loja_id}>
            <InputLabel>{isLoading ? "Carregando" : "Condições de pagamento"}</InputLabel>
            <Select
                value={value?.id || ""}
                onChange={(event) => {
                    const selectedOption = listData.find(i => i.id === event.target.value);
                    onChange(selectedOption ? selectedOption : null);
                }}
                label={isLoading ? "Carregando" : "Condições de pagamento"}
            >
                {listData.map((i) => (
                    <MenuItem key={i.id} value={i.id}>
                        {i.nome}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    )
}

interface SelectSimpleApiQueryProps {
    value: IDataCondicoesPagamentoComercial | null
    onChange: (arg: IDataCondicoesPagamentoComercial | null) => void,
    loja_id: number | null,
    condicoes_pagamento_blocked: number[] | null,
    valor_total: number,
    situacao_financeira: string,
    produtor_rural: boolean,
    tipo_publico: string,
    codigo_publico: string,
    status?: "Ativa" | "Inativa"
    desabilitarInput?: boolean
    autoSelectFirst?: boolean
    defaultValue?: boolean
}